<template lang="pug">
v-app
  em-menu
  v-content
    v-container
      .content-area
        .desciption
          h1.display-1 管理者管理
          p 管理者の追加/閲覧ができます
          v-layout(row, justify-center)
          v-dialog(v-model='addDialog', persistent, max-width='600px')
            template(v-slot:activator='{ on }')
              v-btn(color='primary', depressed, v-on='on') 新規追加
            v-card
              v-card-title
                span.headline 管理者登録
              v-card-text
                v-container(grid-list-md)
                  v-layout(wrap)
                    v-flex(xs12)
                      v-text-field(label='名前', required='', v-model='admin.name')
                    v-flex(xs12)
                      v-text-field(label='メールアドレス*', required='', v-model='admin.email')
                  small *indicates required field
              v-card-actions
                v-spacer
                v-btn(color='blue darken-1', flat='', @click='addDialog = false') Close
                v-btn(color='blue darken-1', flat='', @click='addAdmin') Save
          v-data-table.elevation-1(:headers='headers', :items='data')
            template(v-slot:items='props')
              td.text-xs {{ props.item.id }}
              td.text-xs {{ props.item.name }}
              td.text-xs {{ props.item.email }}
              td.text-xs {{ props.item.status }}
              td.text-xs {{ props.item.regdt }}
</template>
<script>
import API from '@/api/api.js'
import EmMenu from '@/components/organisms/EmMenu.vue'
import DisplayDataUtil from '@/utils/DisplayDataUtil'

export default {
  name: 'admin',
  components: {
    EmMenu
  },
  data () {
    return {
      addDialog: false,
      admin: {},
      headers: [ // テーブルのヘッダーを構造的に定義
        { text: 'ID', align: 'left', value: 'id', sortable: false },
        { text: '名前', align: 'left', value: 'name', sortable: false },
        { text: 'メールアドレス', align: 'left', value: 'email', sortable: false },
        { text: 'ステータス', align: 'left', value: 'status', sortable: false },
        { text: '登録日時', align: 'left', value: 'regdt', sortable: false }
      ],
      data: []
    }
  },
  computed: {
  },
  methods: {
    getAdminList () {
      API.GetAdminUserList().then(result => {
        this.data = []
        result.users.forEach((data) => {
          this.data.push({
            id: data.id,
            name: data.name,
            email: data.email,
            status: data.status,
            regdt: DisplayDataUtil.convertTimestampToDateFormat(data.regdt)
          })
        })
        if (this.data.length === 0) {
          this.noDataText = 'データまだ登録されていません。'
        }
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    addAdmin () {
      API.AddAdminUser({ param: this.getRequestParam() }).then(result => {
        alert('新しい管理者が追加されました.')
        this.getAdminList()
        this.addDialog = false
        this.admin = {}
      }).catch(() => {
        alert('エラーが発生しました')
      })
    },
    getRequestParam () { // this.pushからAdd/Update用のリクエストパラメータを作成する
      return {
        name: this.admin.name,
        email: this.admin.email
      }
    }
  },
  created () {
    this.getAdminList()
  }
}
</script>
<style lang="stylus" scoped>

.content-area
  display flex
  flex-direction column

</style>
